import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box, Button, Typography } from '@mui/material';
import calcite from '../../assets/images/products/calcite.jpeg';
import calciumCarbonate from '../../assets/images/products/calcium-carbonate.jpg';
import calciumHydroxide from '../../assets/images/products/calcium-hydroxide.jpg';
import calciumOxide from '../../assets/images/products/calcium-oxide.jpg';
import dolomite from '../../assets/images/products/dolomite.jpeg';
import limeStone from '../../assets/images/products/lime-stone.jpg';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import HandshakeIcon from '@mui/icons-material/Handshake';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import Groups2Icon from '@mui/icons-material/Groups2';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import { Email, EmailOutlined } from '@mui/icons-material';
import logo from '../../assets/images/alrabie_logo.png';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';



const Btn = styled('button')({
    border: 'none',
    backgroundColor: 'inherit',
    marginBottom: '3px',
    cursor: 'pointer',
    textAlign: 'start',
    padding: '2px 0px',
    color: 'lightslategrey',
});

const Footer = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();


const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/files/privacy_policy.pdf'; // PDF file inside public/files
    link.download = 'privacy_policy.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div dir='ltr' style={{marginTop: '50px', padding: '10px 20px',}}>
        <Box sx={{display:'flex', justifyContent: 'space-between',alignItems: 'flex-start', flexWrap:'wrap', gap: '20px', marginTop: '30px', padding: '20px 20px', borderTop: '1px solid rgb(218, 219, 220)'}}>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', gap: '10px'}}>
                <img src={logo} alt='nana-logo' width='145' style={{ cursor: 'pointer' }} onClick={() => navigate('/')} />
                <div style={{fontSize: '12px', color:'lightslategrey'}}>Al Rabie for supplying stone materials</div>
                <div style={{display: 'flex', gap: '20px'}}>
                    <WhatsAppIcon sx={{fontSize:'25px', cursor:'pointer', color: 'green'}}  onClick={() => window.open('https://wa.me/message/KYPBTWXSB56LK1', '_blank')} />
                    <FacebookIcon  sx={{fontSize:'25px', cursor:'pointer', color: 'blue'}} onClick={() => window.open('https://www.facebook.com/AlRabieGroup', '_blank')} />
                    <InstagramIcon sx={{fontSize:'25px', cursor:'pointer', color: 'deeppink'}} onClick={() => window.open('https://www.instagram.com/alrabiegroup/', '_blank')} />
                </div>
            </div>
            
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <h5 style={{margin: '0px 0px 10px', color: '#9a4a20'}}>About us</h5>
                <Btn onClick={() => navigate('/about')}>Company profile</Btn>
                <Btn onClick={() => navigate('/about')}>Certifications and TDS analysis</Btn>
                <Btn onClick={handleDownload}>Privacy Policy</Btn>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <h5 style={{margin: '0px 0px 10px', color: '#9a4a20'}}>Products</h5>
                <Btn onClick={() => navigate('/products')}>Limestone</Btn>
                <Btn onClick={() => navigate('/products')}>Calcium Carbonate</Btn>
                <Btn onClick={() => navigate('/products')}>Calcium Hydroxide</Btn>
                <Btn onClick={() => navigate('/products')}>Calcium Oxide</Btn>
                <Btn onClick={() => navigate('/products')}>Dolomite</Btn>
                <Btn onClick={() => navigate('/products')}>Calcite</Btn>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <h5 style={{margin: '0px 0px 10px', color: '#9a4a20'}}>Applications</h5>
                <Btn onClick={() => navigate('/applications')}>ANIMAL FEED INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>AGRICULTURAL FERTILIZER INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>PETROLEUM AND GAS INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>GLASS INDUSTRYy</Btn>
                <Btn onClick={() => navigate('/applications')}>IRON AND STEEL INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>PAINT INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>PLASTICS AND POLYMERS INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>CONSTRUCTION MATERIALS INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>CEMENT INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>FOOD INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>RUBBER INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>PHARMACEUTICAL INDUSTRY</Btn>
                <Btn onClick={() => navigate('/applications')}>PAPER INDUSTRY</Btn>
            </div>

            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                <h5 style={{margin: '0px 0px 10px', color: '#9a4a20'}}>Contact us</h5>
                <div style={{display: 'flex', gap: '5px'}}>
                    <span style={{fontSize: '12px', fontWeight: 600,  color: '#9a4a20', marginBottom: '8px'}}>Web:</span><span style={{color: 'lightslategrey',fontSize: '12px'}}>www.alrabiegroup.com</span>
                </div>

                <div style={{display: 'flex', gap: '5px'}}>
                    <span style={{fontSize: '12px', fontWeight: 600,  color: '#9a4a20', marginBottom: '8px'}}>Mobile:</span><span style={{color: 'lightslategrey',fontSize: '12px'}}>+201090774575 | +201067635311</span>
                </div>


                <div style={{display: 'flex', gap: '5px'}}>
                    <span style={{fontSize: '12px', fontWeight: 600,  color: '#9a4a20', marginBottom: '8px'}}>Landline:</span><span style={{color: 'lightslategrey',fontSize: '12px'}}>+20227004835 | +20862240022</span>
                </div>

               
                <div style={{display: 'flex', gap: '5px'}}>
                    <span style={{fontSize: '12px', fontWeight: 600,  color: '#9a4a20', marginBottom: '8px'}}>Email:</span><span style={{color: 'lightslategrey',fontSize: '12px'}}>info@Alrabiegroup.com | sales@Alrabiegroup.com</span>
                </div>

                <div style={{display: 'flex', gap: '5px'}}>
                    <span style={{fontSize: '12px', fontWeight: 600,  color: '#9a4a20', marginBottom: '8px'}}>Address:</span><span style={{color: 'lightslategrey',fontSize: '12px'}}>98 Al Amal Buildings, Al Autostrad | AlMaadi, Cairo, Egypt</span>
                </div>

            </div>
        </Box>
    </div>
  );
};

export default Footer;
